import * as types from "../../types";
import Immutable from "immutable";
import {
  detalleSolicitudEntity,
  distribucionSolicitudEntity,
} from "../../utils/constants";
import { isPrimitive } from "util";

const INITIAL_STATE = Immutable.fromJS({
  solicitante: {},
  cafeterias: [],
  saving: false,
  modalAdicionarCenco: {
    show: false,
    data: {},
  },
  modalAdicionarDetalle: {
    show: false,
    data: {},
  },
  loading: false,
});

export default function(state = INITIAL_STATE, action) {
  let temp;
  switch (action.type) {
    case types.NUEVASOLICITUD_INICIALIZAR_ESTADO:
      state = INITIAL_STATE;
      state = state.set("solicitante", action.payload.user);
      return state;
    case types.NUEVASOLICITUD_REINICIAR_ESTADO:
      return INITIAL_STATE;
    case types.NUEVASOLICITUD_REINICIAR_CAMPO:
      state = {...state};
      state = state.setIn(action.payload, "");
      return state;
    case types.NUEVASOLICITUD_GUARDANDO:
      state = state.set("saving", action.payload);
      return state;
    case types.NUEVASOLICITUD_LOADING:
      state = state.set("loading", action.payload);
      return state;
    case types.NUEVASOLICITUD_ELIMINAR_DETALLE:
      state
        .getIn("detalles.data".split("."))
        .valueSeq()
        .filter((x) => x.get("selected"))
        .forEach((x) => {
          state = state.deleteIn(
            `detalles.data.${x.get("id3n71f13r")}`.split(".")
          );
        });
      state = state.setIn(
        `detalles.ids`.split("."),
        state
          .getIn(`detalles.data`.split("."))
          .keySeq()
          .toList()
      );
      state = state.setIn(
        `detalles.records`.split("."),
        state.getIn(`detalles.ids`.split(".")).count()
      );
      return state;
    case types.NUEVASOLICITUD_ELIMINAR_RECURSO:
      state
        .getIn("distribuciones.data".split("."))
        .valueSeq()
        .filter((x) => x.get("selected"))
        .forEach((x) => {
          state = state.deleteIn(
            `distribuciones.data.${x.get("id3n71f13r")}`.split(".")
          );
        });
      state = state.setIn(
        `distribuciones.ids`.split("."),
        state
          .getIn(`distribuciones.data`.split("."))
          .keySeq()
          .toList()
      );
      state = state.setIn(
        `distribuciones.records`.split("."),
        state.getIn(`distribuciones.ids`.split(".")).count()
      );
      return state;
    case types.NUEVASOLICITUD_POBLAR_PARAMETROS:
      state = state.set(
        action.payload.parametro,
        Immutable.fromJS(action.payload.data)
      );
      return state;
    case types.NUEVASOLICITUD_MOSTRAR_MODAL_ADICIONAR_DETALLES:
      state = state.setIn(
        ["modalAdicionarDetalle", "show"],
        action.payload.show
      );
      if (!action.payload.show) {
        state = state.set(
          "modalAdicionarDetalle",
          INITIAL_STATE.get("modalAdicionarDetalle")
        );
      } else {
        if (action.payload.id) {
          temp = state.getIn(`detalles.data.${action.payload.id}`.split("."));
          state = state.setIn(["modalAdicionarDetalle", "data"], temp);
        } else {
          state = state.setIn(
            ["modalAdicionarDetalle", "data"],
            Immutable.fromJS(detalleSolicitudEntity())
          );
        }
        Object.keys(action.payload.lists).forEach((x) => {
          state = state.setIn(
            `modalAdicionarDetalle.data.${x}`.split("."),
            Immutable.fromJS(action.payload.lists[x])
          );
        });
      }
      return state;
    case types.NUEVASOLICITUD_ACTUALIZAR_DETALLES:
      temp = state.getIn(["modalAdicionarDetalle", "data", "id3n71f13r"]);
      state = state.setIn(
        `detalles.data.${temp}`.split("."),
        state.getIn("modalAdicionarDetalle.data".split("."))
      );
      return state;
    case types.NUEVASOLICITUD_MOSTRAR_MODAL_ADICIONAR_CENCOS:
      state = state.setIn(["modalAdicionarCenco", "show"], action.payload.show);
      if (!action.payload.show) {
        state = state.setIn(
          ["modalAdicionarCenco", "data"],
          Immutable.fromJS({})
        );
      } else {
        if (action.payload.id) {
          temp = state.getIn(
            `distribuciones.data.${action.payload.id}`.split(".")
          );
          state = state.setIn(["modalAdicionarCenco", "data"], temp);
        } else {
          state = state.setIn(
            ["modalAdicionarCenco", "data"],
            Immutable.fromJS(distribucionSolicitudEntity())
          );
        }
      }
      return state;
    case types.NUEVASOLICITUD_ACTUALIZAR_DISTRIBUCIONES:
      temp = state.getIn(["modalAdicionarCenco", "data", "id3n71f13r"]);
      state = state.setIn(
        `distribuciones.data.${temp}`.split("."),
        state.getIn(["modalAdicionarCenco", "data"])
      );
      return state;
    case types.NUEVASOLICITUD_POBLAR_OPCIONES_TIPO_SERVICIO:
      Object.keys(action.payload.lists).forEach((x) => {
        if (x === "tipos_producto") {
          state = state.setIn(
            `modalAdicionarDetalle.data.tipo_producto`.split("."),
            null
          );
          state = state.setIn(
            `modalAdicionarDetalle.data.descripcion`.split("."),
            null
          );
          state = state.setIn(
            `modalAdicionarDetalle.data.valor_maximo`.split("."),
            null
          );
          state = state.setIn(
            `modalAdicionarDetalle.data.valor_unitario`.split("."),
            null
          );
          state = state.setIn(
            `modalAdicionarDetalle.data.valor_fijo`.split("."),
            null
          );
          state = state.setIn(
            `modalAdicionarDetalle.data.preaprobacion`.split("."),
            null
          );
          state = state.setIn(
            `modalAdicionarDetalle.data.cantidad`.split("."),
            null
          );
        }
        state = state.setIn(
          `modalAdicionarDetalle.data.${x}`.split("."),
          isPrimitive
            ? action.payload.lists[x]
            : Immutable.fromJS(action.payload.lists[x])
        );
      });
      return state;
    case types.NUEVASOLICITUD_RECALCULAR_TOTAL_SOLICITUD:
      temp = state.getIn("detalles.data".split(".")).reduce((a, b) => {
        a += b.get("subtotal");
        return a;
      }, 0);
      state
        .getIn("distribuciones.data".split("."))
        .keySeq()
        .forEach((x) => {
          const participacion = state.getIn(
            `distribuciones.data.${x}.porcentaje`.split(".")
          );
          state = state.setIn(
            `distribuciones.data.${x}.total`.split("."),
            (participacion / 100) * temp
          );
        });
      return state;
    default:
      return state;
  }
}

const getLastId = (state, table) => {
  let lastid = state
    .getIn(`${table}.data`.split("."))
    .keySeq()
    .reduce((k, nk) => {
      const num = Number(nk);
      return num > k ? num : k;
    }, 0);

  return lastid + 1;
};
